import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-brightness-low",
  templateUrl: "./med-icon-brightness-low.component.html",
})
export class MedIconBrightnessLowComponent extends SvgMixinComponent {}
